const nameField = 'task*taskName';
const statusField = 'task*status';

export const validateTaskColumns = (columnOrder: string[]): string[] => {
  if (columnOrder.includes(statusField) && !columnOrder.includes(nameField)) {
    columnOrder.unshift(nameField);
  } else if (
    columnOrder.includes(nameField) &&
    !columnOrder.includes(statusField)
  ) {
    columnOrder.splice(1, 0, statusField);
  } else if (
    !columnOrder.includes(nameField) &&
    !columnOrder.includes(statusField)
  ) {
    columnOrder.unshift(nameField, statusField);
  }

  return columnOrder;
};
